import { useMutation } from '@tanstack/react-query';
import {
  ClassifierMappingsFormDataSchema,
  ClassifierMappingsType,
} from '../types';
import { apiClient, ApiErrorResponse } from '../../common/ApiClient';
import { ClassifierMappingUrl } from './ClassifierMappingUrl';
import { RcFile } from 'antd/es/upload';

interface IArgs {
  file: string | Blob | RcFile;
}

export const useMutateClassifierMappingUpload = (
  onProgress?: (progress: number) => void
) =>
  useMutation<Partial<ClassifierMappingsType>, ApiErrorResponse, IArgs>({
    mutationKey: ['classifierMappingUpload'],
    mutationFn: (args) =>
      apiClient
        .post(ClassifierMappingUrl.CLASSIFIER_MAPPING_UPLOAD, args, {
          headers: { 'content-type': 'multipart/form-data' },
          onUploadProgress: (progress) => {
            if (!progress.total) {
              return;
            }
            onProgress?.((progress.loaded / progress.total) * 100);
          },
        })
        .then((response) =>
          ClassifierMappingsFormDataSchema.parse(response.data)
        ),
  });
